import { Spacing } from 'zens-storybook'
import React, { Suspense } from 'react'
import { StyleSheet, View } from 'react-native'
import { useNumberParams, useArrayParams } from 'zens-router'
import { LayoutHeader, WorkspaceFeedback, WorkspaceHeader, WorkspaceInfo } from '@dms/component'
import { useWorkspace, useFloor, useBuilding } from 'zens-store'
import { ProgramType } from '@dms/component/schedule/legend'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.S,
    padding: Spacing.S,
  },
})

const WorkspaceDetail = () => {
  const [{ companyId, workspaceId }] = useNumberParams()
  const [{ program }, setArrayParams] = useArrayParams<ProgramType>()

  // FIXME This should be done inside the components to get suspense working
  const workspace = useWorkspace({ companyId, workspaceId })
  // FIXME This should be a single query, API needs to be updated
  const floorId = workspace.data?.floorId || 0
  const floor = useFloor({ companyId, floorId })
  const buildingId = floor.data?.buildingId || 0
  const building = useBuilding({ companyId, buildingId })
  const locationId = building.data?.locationId

  function updateProgramTypes(program: ProgramType[]) {
    setArrayParams({ program })
  }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <WorkspaceHeader companyId={companyId} workspaceId={workspaceId} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<WorkspaceInfo.Skeleton />}>
          <WorkspaceInfo
            companyId={companyId}
            workspaceId={workspaceId}
            programTypes={program}
            onChangeProgramTypes={updateProgramTypes}
          />
        </Suspense>
        <Suspense fallback={<WorkspaceFeedback.Skeleton />}>
          <WorkspaceFeedback companyId={companyId} locationId={locationId} workspaceId={workspaceId} />
        </Suspense>
      </View>
    </View>
  )
}

export default WorkspaceDetail
